import {
  escalationsResponseSchema,
  type EscalationsResponse,
} from '@lms/shared-types'
import { apiRequest } from './client'

/**
 * GET /api/v1/escalations — Director Blackout Exceptions queue.
 *
 * Returns leaves that overlap an active or upcoming director-level
 * blackout. Director / exec_director roles only; HR can view for
 * diagnostics. Below director: 403.
 */
export async function listEscalations(): Promise<EscalationsResponse> {
  const raw = await apiRequest<unknown>('/api/v1/escalations')
  return escalationsResponseSchema.parse(raw)
}

